<template>
    <div>
        <div class="banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
        <!-- <div class="main1">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">中机六院</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/e01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/e02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/e03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/e04.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/swc/a08.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/swc/a09.jpg" alt="">
                </div>
            </div>
        </div>
        
        <div class="main2">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">某研究所</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/b01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/b02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/b03.gif" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/b04.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main3">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">壹米滴答供应链</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/c01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/c02.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main2">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">恒天重工股份有限公司</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/d01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/d02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/d03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/d04.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/d05.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/d06.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main1">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">河南城建学院</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/a01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/a02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/a03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/a04.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/a05.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/a06.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main2">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">中原工学院</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/f01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/f02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/f03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="2s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/f04.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main1">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">疫情隔离餐保障</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/g01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/g02.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/g03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="1s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/dxal/g04.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="main2">
            <div class="title1 wow animate__animated animate__zoomIn animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">紧急团餐保障</div>
            <div class="content1 tc">
                <div class="tc1 wow animate__animated animate__fadeInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/h01.jpg" alt="">
                </div>
                <div class="tc2">
                    <div class="tc2l wow animate__animated animate__fadeInDown animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                        <img src="../../assets/dxal/h04.jpg" alt="">
                    </div>
                    <div class="tc2r wow animate__animated animate__fadeInUp animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                        <img src="../../assets/dxal/h03.jpg" alt="">
                    </div>
                </div>
                <div class="tc3 wow animate__animated animate__fadeInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/dxal/h02.jpg" alt="">
                </div>
            </div>
        </div> -->
        <!-- <div class="content">
            <div class="content_title"></div>
            <div class="content_img">

            </div>
        </div> -->
        <el-tabs class="content" tab-position="left">
            <el-tab-pane label="中机六院" class="content_control">
                    <el-carousel :interval="2000" type="card" height="400px">
                        <el-carousel-item>
                            <img src="../../assets/dxal/e01.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/dxal/e02.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/dxal/e03.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/dxal/e04.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/swc/a08.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/swc/a09.jpg" alt="">
                        </el-carousel-item>
                    </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="某研究所" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/b01.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/b02.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/b03.gif" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/b04.jpg" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            
            <el-tab-pane label="恒天重工股份有限公司" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/d01.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/d02.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/d03.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/d04.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/d05.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/d06.jpg" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
             <el-tab-pane label="恒达智控" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a2.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a3.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a1.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a4.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a5.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hd-a6.png" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="司法局" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/sfj-a3.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/sfj-a4.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/sfj-a2.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/sfj-a1.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/sfj-a5.png" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="海为酒店" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a4.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a1.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a2.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a3.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a5.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a6.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a7.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/hw-a8.png" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="中原工学院" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/f01.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/f02.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/f03.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/f04.jpg" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="河南城建学院" class="content_control">
                <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/a01.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/a02.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/a03.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/a04.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/a05.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/a06.jpg" alt="">
                    </el-carousel-item>
                </el-carousel>
            </el-tab-pane>
            <el-tab-pane label="壹米滴答供应链" class="content_control">
               <div style="width:80%;display:flex;margin:0 auto;">
                    <div class="img1">
                        <img src="../../assets/dxal/c01.jpg" alt="">
                    </div>
                    <div class="img1" style="margin-top: 100px;">
                        <img src="../../assets/dxal/c02.jpg" alt="">
                    </div>
               </div>
            </el-tab-pane>
            <el-tab-pane label="疫情隔离餐保障" class="content_control">
                <!-- <el-carousel :interval="2000" type="card" height="400px">
                    <el-carousel-item>
                        <img src="../../assets/dxal/g01.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/g02.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/g03.jpg" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../../assets/dxal/g04.jpg" alt="">
                    </el-carousel-item>
                </el-carousel> -->
                <div style="width:80%;display:flex;margin:0 auto;flex-wrap: wrap;">
                    <div class="img1 ">
                        <img src="../../assets/dxal/g01.jpg" alt="">
                    </div>
                    <div class="img1" style="margin-top:30px;">
                        <img src="../../assets/dxal/g02.jpg" alt="">
                    </div>
                    <div class="img1">
                        <img src="../../assets/dxal/g03.jpg" alt="">
                    </div>
                    <div class="img1" style="margin-top:30px;">
                        <img src="../../assets/dxal/g04.jpg" alt="">
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="紧急团餐保障" class="content_control tc">
                <div style="width:80%;display:flex;margin:0 auto;">
                    <div class="tc1 " >
                        <img src="@/assets/dxal/h01.jpg" alt="">
                    </div>
                    <div class="tc2">
                        <div class="tc2l ">
                            <img src="@/assets/dxal/h04.jpg" alt="">
                        </div>
                        <div class="tc2r">
                            <img src="@/assets/dxal/h03.jpg" alt="">
                        </div>
                    </div>
                    <div class="tc3">
                        <img src="@/assets/dxal/h02.jpg" alt="">
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'
export default {
    data(){
        return{
        }
    },
    mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
    var wow = new WOW({
        boxClass: 'wow',///动画元件css类（默认为wow）
        animateClass: 'animated',//动画css类（默认为animated） 
        offset: 0,//到元素距离触发动画（当默认为0） 
        mobile: true, //在移动设备上触发动画（默认为true） 
        live: true//对异步加载的内容进行操作（默认为true）
    })
    wow.init()
    }),
    new Swiper(".banner",{
        loop:true, //循环模式选项

        // 如果需要分页器
        pagination:{
            el:".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation:{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
},
}
</script>

<style scoped>
.banner{
    width: 100%;
    height: 3.5rem;
    overflow: hidden;
}
/* .banner:hover img{
    transform: scale(1.2);
} */
.banner img{
    /* transition: all .4s; */
    width: 100%;
    height: 100%;
    /* display: block;
    object-fit: cover; */
}
.main1,
.main2{
    width: 100%;
    /* height: 3rem; */
    background-color: #ededed;
    /* margin: 20px auto; */
    padding-bottom: 20px;
}
.title1{
    font-size: .1rem;
    font-weight: 700;
    padding: 20px 0;
}
.content1{
    width: 70%;
    /* height: 2.66rem; */
    margin: 0 auto;
    display: flex;
    /* background-color: green; */
    flex-wrap: wrap;
}
.img1,.img2{
    width: 48%;
    height: 400px;
    padding: 0 0.5%;
}
img{
    width: 100%;
    height: 100%;
}
.text1{
    width: 50%;
    /* height: 2.66rem; */
    /* background-color: yellow; */
}
/* 第二部分 */
.main2{
    background-color: #fff;
}
.content2{
    width: 60%;
    height: 2.6rem;
    margin: 0 auto;
}
/* 第三部分 */
.main3{
    width: 100%;
    height: 2.85rem;
    background-color: #ededed;
    padding-bottom: 20px;
}
.img3{
    width: 50%;
    height: 375px;
}
.content3{
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}
.tc{
    position: relative;
    height: 600px;
    display: flex;
    justify-content: space-between;
}
.tc1{
    width: 24%;
    height: 600px;
    padding-right: 10px;
}
.tc2{
    width: 49%;
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.tc3{
    width: 24%;
    height:600px;
    padding-left: 10px;
}
.tc2l{
    width: 100%;
    height: 300px;
    padding-bottom: 5px;
}
.tc2r{
    width: 100%;
    height: 300px;
    padding-top: 5px;
}

/* 升级之后 */
.content{
    width: 100%;
    /* height: 80vh; */
    background-color: #ededed;
    margin-top: 12px;
    position: relative;
}
::v-deep .el-tabs__item.is-active{
    color: #b11212 !important;
}
::v-deep .el-tabs__active-bar{
    background-color:#b11212 !important ;
}
::v-deep .el-tabs__item:hover{
    color: #b11212 !important;
}
.content_control{
    display: flex;
    flex-wrap: wrap;
}
/* 轮播 */
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 500px;
    margin: 0;
  }
  .el-carousel--horizontal{
    width: 80%;
    margin: 0 auto;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>